import { ApiClient } from '../../ApiClient';
import { ActiveImportJob, ImportJobStatus } from '@domain/connection/models/ImportJob';

export class ImportJobsDataSource {
  constructor(private api: ApiClient) {
  }

  async fetchJobStatus(connector: string, jobId: string): Promise<ImportJobStatus> {
    const response = await this.api.get<ImportJobStatus>(`/connections/${connector}/jobs/${jobId}`);
    return response.data;
  }

  async fetchActiveJobs(): Promise<ActiveImportJob[]> {
    const response = await this.api.get<ActiveImportJob[]>('/connections/jobs/active');
    return response.data;
  }
}
